<template>
  <div class="w-100 float-left">
    <b-modal :visible="instanceToDelete !== null"
      title="Remover Contato"
      class="modal-primary"
      cancel-title="Cancelar"
      @ok="remove"
      @cancel="instanceToDelete = null"
      @hide="instanceToDelete = null">
      Deseja remover o contato? Essa ação não poderá ser desfeita!
    </b-modal>
    <b-modal :visible="removeAll"
      title="Remover mensagens"
      class="modal-primary"
      cancel-title="Cancelar"
      @ok="removeInMass"
      @cancel="removeAll = false"
      @hide="removeAll = false">
      Deseja remover todos os contatos selecionados? Essa ação não poderá ser desfeita!
    </b-modal>
    <div class="animated fadeIn" v-if="entity">
      <div class="wrapper wrapper-content">
        <div class="row">
          <div class="col-lg-2 mailbox-filter card" v-if="entity.filters.length > 0">
            <div class="float-e-margins">
              <div class="card-header">
                <h1>
                  Filtros
                </h1>
              </div>
              <a @click.prevent="resetSearch()">
                <i class="fa fa-inbox mr-1"></i>
                Todos
              </a>
              <a v-for="(filter, index) in entity.filters"
                :key="`filter-${index}`"
                :class="{ active: filterIsActive(filter) }"
                @click.prevent="searchByFilter(filter)">
                <i :class="`mr-1 ${filter.icon}`"></i>
                {{ filter.label }}
              </a>
            </div>
          </div>
          <div class="col-lg-10" :class="entity.filters.length > 0 ? '' : 'animated fadeInRight'">
            <div class="mailbox-container card" v-if="!selectedContact">
              <div class="card-body">
                <div class="row">
                  <form class="col-xl-12 col-lg-12 col-md-12" @submit.stop.prevent="firstPageSearch">
                    <div class="input-group search">
                      <input type="text"
                        v-model="input.q"
                        @input.prevent="callDebouncedFirstPageSearch"
                        @blur.prevent="firstPageSearch"
                        class="form-control input-sm"
                        id="search"
                        ref="search"
                        placeholder="Buscar"
                        autofocus />
                    </div>
                  </form>
                </div>
                <br/>
                <table class="table table-sm col-sm-12 table-mail">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Assunto</th>
                      <th>E-mail</th>
                      <th>Celular</th>
                      <th>Recebido em</th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="collection.length === 0">
                      <td colspan="10" class="text-center">
                        Não há nada para ser exibido
                      </td>
                    </tr>
                    <tr v-if="collection.length > 0"
                      v-for="(instance, index) in collection"
                      :key="instance[index]"
                      :class="{
                        read: instance.status,
                        unread: !instance.status,
                        selected: instance.selected
                      }">
                      <td>
                        <a href="javascript:void(0)" @click="selectedContact = instance">
                          {{ instance.name || 'Anônimo' }}
                        </a>
                      </td>
                      <td>
                        <a href="javascript:void(0)" @click="selectedContact = instance">
                          {{ instance.subject.name || 'Sem assunto' | truncate(60) }}
                        </a>
                      </td>
                      <td>
                        <a href="javascript:void(0)" @click="selectedContact = instance">
                          {{ instance.email || '' }}
                        </a>
                      </td>
                      <td>
                        <a href="javascript:void(0)" @click="selectedContact = instance">
                          {{ instance.phone_number || '' }}
                        </a>
                      </td>
                      <td>
                        <a href="javascript:void(0)" @click="selectedContact = instance">
                          {{ instance.created_at | moment('DD/MM/YYYY HH:mm') }}
                        </a>
                      </td>
                      <td class="text-center">
                        <i class="fa fa-trash-o"
                          v-b-tooltip
                          title="Remover"
                          @click="showDeleteModal(instance)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination-module" v-if="pagination.total > 0">
                  <div class="align-left">
                    Página <b>{{ pagination.current_page }}</b> de <b>{{ pagination.last_page }}</b>,&nbsp;
                    <b>{{ pagination.from }}</b> até <b>{{ pagination.to }}</b> de <b>{{ pagination.total }}</b> registros
                  </div>
                  <div class="align-left">
                    <b-pagination v-model="input.page"
                      @change="search"
                      :total-rows="pagination.total"
                      :per-page="pagination.per_page"
                      :limit="3"
                      :hide-ellipsis="true"
                      align="right" >
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
            <!-- A message was selected  -->
            <div v-else class="card" >
              <div class="card-header">
                <div class="row">
                  <h1 class="col-lg-6">
                    Mensagem
                  </h1>
                  <div class="col-lg-6 text-right" style="padding-top:8px">
                    <div class="btn-group">
                      <a class="btn " @click="selectedContact = null">
                        <i class="fa fa-chevron-left" style="font-size:13px;"></i> Voltar
                      </a>
                      <a class="btn " @click="showDeleteModal(selectedContact)">
                        <i class="fa fa-trash-o"></i> Deletar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <ul class="full list col-lg-12">
                  <li>
                    <span class="full part">
                      <b class="col-title no-padding">Enviado em:</b>
                      {{ selectedContact.created_at | moment('DD/MM/YYYY HH:mm') }}
                    </span>
                  </li>
                  <li>
                    <span class="float-left full part">
                      <b class="col-title no-padding">
                        Nome:
                      </b>
                      <span v-if="selectedContact.name || selectedContact.email">
                        {{ selectedContact.name || '' }} ({{ selectedContact.email || '' }})
                      </span>
                      <span v-else>
                        Anônimo
                      </span>
                    </span>
                  </li>
                  <li>
                    <span class="full part">
                      <b class="col-title no-padding">Telefone:</b>
                      {{ selectedContact.phone_number || '' }}
                    </span>
                  </li>
                  <li v-if="selectedContact.address">
                    <span class="full part">
                      <b class="col-title no-padding">Cidade:</b>
                      {{ selectedContact.address.city.name }} / {{ selectedContact.address.city.uf }}
                    </span>
                  </li>
                  <li>
                    <span class="full part">
                      <b class="col-title no-padding">Assunto:</b>
                      {{ selectedContact.subject.name || '' }}
                    </span>
                  </li>
                  <li>
                    <span class="full part">
                      <b class="col-title no-padding">Cidade / UF:</b>
                      {{ selectedContact.city || '' }} / {{ selectedContact.state || '' }}
                    </span>
                  </li>
                </ul>
                <div class="col-lg-12">
                  <span class="float-left full part">
                    <b>Mensagem:</b>
                  </span>
                  <div class="full">
                    {{ selectedContact[bodyField] || 'Não há mensagem' }}
                  </div>
                </div>
              </div>
              <div class="col-lg-12 no-padding"
                v-if="options.attachments === true && selectedContact[attachmentsField]">
                <div class="mail-attachment" v-if="selectedContact[attachmentsField].length > 0">
                  <template v-if="options.multipleAttachments">
                    <div class="file"
                      v-for="(file, index) in selectedContact[attachmentsField]"
                      :key="`selected-contact-file-${index}`">
                      <a v-if="file._links.download" :href="file._links.download || '!#'">
                        <i class="fa fa-file"></i>
                        {{ file.file.original_name }}<br/>
                      </a>
                    </div>
                  </template>
                  <template v-else>
                    <div class="file">
                      <a v-if="selectedContact._links.download" :href="selectedContact._links.download || '!#'">
                        <i class="fa fa-file"></i>
                        {{ selectedContact.file[0].original_name }}<br/>
                      </a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get, clone, union, omit, pickBy, cloneDeep, debounce } from 'lodash'
export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      instanceToDelete: null,
      processing: false,
      collection: [],
      selected: [],
      removeAll: false,
      selectedContact: null,
      optionsSelecteds: [],
      input: {},
      emptyInput: {
        page: 1,
        per_page: 10,
        q: '',
        search: [],
        orderBy: {
          name: null,
          direction: 'asc'
        }
      },
      pagination: {},
      emptyPagination: {
        current_page: 1,
        total: 0,
        last_page: null,
        from: 1,
        to: 1,
        per_page: 10
      }
    }
  },

  watch: {
    entity (next, prev) {
      const nextEntity = get(next, 'key', null)
      const previousEntity = get(prev, 'key', null)

      if (nextEntity !== previousEntity) {
        this.resetSearch()
      }
    },

    collection: {
      handler (next, prev) {
        this.selected = this.collection.filter((o) => o.selected === true).map((o) => parseInt(o.id))
      },
      deep: true
    },

    selectedContact (next) {
      if (next && !next.status) {
        const self = this
        const payload = pickBy(omit(next, get(self.options, 'omit', [])), (o) => o != null)

        self.http.update(next.id,
          Object.assign(payload, { status: true })
        ).then(() => {
          self.$nextTick(() => { next.status = true })
        })
      }
    }
  },

  computed: {
    options () { return this.entity.indexOptions || { filters: [] } },

    filters () { return get(this.entity, 'indexOptions.filters', []) },

    attachmentsField () { return get(this.entity, 'attachments', 'attachments') },

    subjectField () { return get(this.options, 'subject', 'subject') },

    bodyField () { return get(this.options, 'body', 'body') },

    allSelected () { return this.selected.length === this.collection.length }
  },

  methods: {
    get,

    removeInMass () {
      this.removeAll = true
    },

    cancelModalRemoveInMass () {
      this.removeAll = false
    },

    run (fc) {
      this[fc]()
    },

    filterIsActive (filter) {
      return union(this.input.search, filter.params).length === this.input.search.length
    },

    action () {
      if (this.optionsSelecteds.length) {
        this.showMassActionOptions = true
      } else {
        this.showMassActionOptions = false
        this.massAction = 0
      }
    },

    hasAttachments (instance) {
      if (instance[this.attachmentsField]) {
        if (instance[this.attachmentsField].constructor === Array) {
          return instance[this.attachmentsField].length > 0
        }
      }

      return instance[this.attachmentsField] !== null
    },

    isIntanceSelected (instance) {
      return this.selected.indexOf(instance.id) !== -1
    },

    toggleSelected (instance) {
      const index = this.selected.indexOf(instance.id)

      if (index !== -1) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(instance.id)
      }
    },

    toggleSelectedAll () {
      const self = this
      const value = self.selected.length !== self.collection.length
      self.collection.map((o) => { o.selected = value })
    },

    showDeleteModal (instance) {
      this.instanceToDelete = instance
    },

    remove () {
      const self = this

      self.processing = true
      self.$Progress.start()

      self.http.destroy(self.instanceToDelete.id)
        .then((res) => {
          self.$Progress.finish()
          self.instanceToDelete = null
          self.selectedContact = null
          self.processing = false
          self.search()

          self.$toasted.success('Contato removido com sucesso')
        })
    },

    callDebouncedFirstPageSearch () {
      this.debouncedFirstPageSearch(this)
    },

    debouncedFirstPageSearch: debounce((context) => {
      context.input.page = context.pagination.current_page = 1

      context.search()
    }, 1000, { 'maxWait': 8000 }),

    firstPageSearch () {
      this.input.page = this.pagination.current_page = 1

      this.search()
    },

    resetSearch () {
      this.pagination = clone(this.emptyPagination)
      this.input = clone(this.emptyInput)

      this.firstPageSearch()
    },

    searchByFilter (filter) {
      if (filter.params) {
        this.input.search = filter.params
      }

      this.firstPageSearch()
    },

    search () {
      const self = this

      // Forces data input page update for request
      this.$nextTick(() => {
        self.$Progress.start()
        self.processing = true
        self.selectedContact = null

        if (self.options.search) {
          self.options.search.forEach(item => {
            if (!self.input.search.includes(item)) {
              self.input.search.push(item)
            }
          })
        }

        let cloneInput = cloneDeep(Object.assign(self.input, {
          with: self.options.with || [],
          orderBy: self.options.orderBy || []
        }))

        if (cloneInput['q']) {
          cloneInput['search'].push(cloneInput['q'])
        }

        delete cloneInput['q']

        self.http
          .index({ params: cloneInput })
          .then((res, body) => {
            self.processing = false
            self.$Progress.finish()
            self.collection = get(res.data, 'collection', [])
            self.pagination = get(res.data, 'pagination', clone(self.emptyPagination))

            self.pagination.per_page = parseInt(self.pagination.per_page, 10)
          })
          .catch((error) => {
            self.error = error
            self.$Progress.fail()
            self.processing = false
            self.collection = []
            self.pagination = clone(self.emptyPagination)

            return null
          })
      })
    },

    applyFormatters (field, value) {
      let result = value

      if (field.formatters) {
        for (let i = 0; i < field.formatters.length; i++) {
          switch (field.formatters[i]['type']) {
            case 'date':
              result = moment(result, 'YYYY-MM-DD HH:mm').format(field.formatters[i]['args'])
          }
        }
      }

      return result
    }
  },

  created () {
    this.resetSearch()
  }
}
</script>

<style lang="scss" scoped>
  a, i, button {
    cursor: pointer !important;
  }

  .select-content {

    padding-right: 0;

    &:before {

      content: '\F0DD';
      font-family: 'fontAwesome';
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translate(0%, -50%);

    }
  }

  .select-options-in-mass {

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    float: left;

    select {

      -webkit-appearance: none;
      border: 1px solid #e6eaef;
      width: 100%;
      float: left;
      outline: none;
      padding: 5px 13px;
      color: #000;
      border-radius: 3px;
      background: #fff;

    }

  }

  .mass-effect {

    display: inline-block;
    background: rgba(222, 222, 222, 0.52);
    border: 1px solid rgba(224, 227, 230, 0.32);
    padding: 3px 5px;

    i {

      color: #2c323f;

    }
  }

  .mass-actions {
    a {
      padding: 14px 20px;
      font-size: 17px;
      height: 100%;
      display: inline-block;
      line-height: 0px;
    }
  }

  .mass-effect-submenu {

    position: absolute;
    padding-top: 30px;
    left: 0;
    width: 100%;
    z-index: 999;
    top: 0;

    &:hover {
      ul {
        display: block;
      }
    }

    ul {

      box-shadow: 0px 2px 3px #eee;
      padding-left: 0px;
      list-style: none;
      display: none;
      overflow: hidden;
      position: absolute;
      width: 100%;

      li {

        border: 1px solid #eee;
        float: left;
        width: 100%;
        clear: both;
        background: #fff;
        margin-bottom: -1px;

        &:hover {

          background: #eee;

        }

        input[type="radio"] {

          margin-left: 4px;
          margin-right: 4px;
          position: absolute;
          opacity: 0;

        }

        label {
          padding: 8px 3px;
          cursor: pointer;
          width: 100%;
          float: left;
        }
      }
    }
  }

  table {
    tr {
      &.unread {
        background-color: #fff;
        font-weight: bold;

        &.selected {
          background-color: #ffc;
        }
      }

      &.read {
        background: #f7f7f7;

        &.selected {
          background-color: #ffc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Mailbox.vue